import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import {
  updateTechnicalMaterial,
  uploadFileTechnicalMaterial,
} from '../../app/store/actions/technicalMaterial';
import FIELDS from '../../data/fields';
import ROUTES from '../../data/routes';
import randomPassword from '../../helpers/generator';
import { history } from '../../routers/AppRouter';
import DropZoneComponent from '../dropzone';
import HeaderComponent from '../table/header/headerComponent';

class TechnicalMaterialForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      technicalMaterialId: null,
      line: '',
      category: '',
      name: '',
      description: '',
      fileUrl: '',
      fileName: '',
      file: null,
      loadImage: false,
      message: '',
      success: '',
    };
  }

  componentDidMount = () => {
    if (this.props.back.location.selectedLine) {
      this.setTheVariables(this.props.back.location.selectedLine);
    }
  }

  setTheVariables = (selectedLine) => {
    this.setState({
      technicalMaterialId: selectedLine.id,
      line: selectedLine.line,
      category: selectedLine.category,
      name: selectedLine.name,
      description: selectedLine.description,
      fileUrl: selectedLine.fileUrl,
      fileName: selectedLine.fileName,
    });
  }

  setValue = (att, value) => {
    this.setState({ [att]: value });
  }

  uploadedFile = async (file, id) => {
    try {
      await this.setState({ loadImage: true });
      const hash = randomPassword();
      const extension = file[0].name.split('.').pop();
      const opico = this.props.settings.name;
      const fileName = `${opico}${hash}.${extension}`;
      const uploadFile = await this.props.uploadFileTechnicalMaterial(file[0], fileName, id);
      return uploadFile.name;
    } catch (erro) {
      throw erro;
    } finally {
      await this.setState({ loadImage: false });
    }
  }

  validateProperties = () => {
    const { file, fileUrl } = this.state;

    if (!file && !fileUrl) {
      this.setState({
        success: '',
        message: I18n.t('selectImage'),
      });
      return false;
    }

    return true;
  }

  updateData = async () => {
    const {
      technicalMaterialId, line, category, name,
      description, file, fileUrl, fileName,
    } = this.state;
    if (this.validateProperties()) {
      try {
        const newFileUrl = (!file && fileUrl) ? fileName : await this.uploadedFile(file, technicalMaterialId);

        const result = await this.props.updateTechnicalMaterial({
          technicalMaterialId,
          line,
          category,
          name,
          description,
          fileUrl: newFileUrl,
        });

        await this.setState({
          fileUrl: result.fileUrl,
          fileName: result.fileName,
          success: I18n.t('changeMade'),
          message: '',
        });
      } catch (err) {
        const error = err.response && err.response.data && err.response.data.error;
        if (error && error.message) {
          const messageError = (error.code && error.details)
            ? `${error.code} - ${error.details} | ${error.message}`
            : error.message;

          this.setState({
            success: '',
            message: messageError,
          });
        } else {
          this.setState({
            success: '',
            message: I18n.t('erroFetch'),
          });
        }
      }
    }
  }

  goBack = () => {
    history.push(ROUTES.TECHNICAL_MATERIAL);
  }

  render() {
    const {
      line, category, name, description,
      fileUrl, file, loadImage,
    } = this.state;

    return (
      <div className="form-main">
        <HeaderComponent
          title={I18n.t('UpdateTechnicalMaterial')}
        />
        <form>
          <div className="row margin-bottom-20 banner-form-div justify-content-center">
            <div className="dropzone-out">
              <DropZoneComponent
                uploadedFile={e => this.setState({ file: e, success: '', message: '' })}
                title={I18n.t('chooseFile')}
                loadImage={loadImage}
                fileName={file && file[0].name}
              />
            </div>
          </div>
          {!!fileUrl && (
            <div className="margin-bottom-20 ml-2 mr-3">
              <a href={fileUrl} target="_blank" className="btn btn-primary btn-lg btn-block" rel="noreferrer">
                {I18n.t('download')}
              </a>
            </div>
          )}
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('line')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('line', e.target.value)}
              value={line}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('category')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('category', e.target.value)}
              value={category}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('name')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('name', e.target.value)}
              value={name}
            />
          </div>
          <div className="form-group">
            <p className="margin-bottom-2">
              {I18n.t('description')}
            </p>
            <input
              className="form-control"
              maxLength={FIELDS.max}
              type="text"
              placeholder=""
              onChange={e => this.setValue('description', e.target.value)}
              value={description}
            />
          </div>

          <div className="row margin-left-0 margin-top-10">
            <button
              className="btn btn-warning margin-right-15"
              type="button"
              onClick={this.goBack}
            >
              {I18n.t('return')}
            </button>

            <button
              className="btn btn-dark margin"
              type="button"
              onClick={this.updateData}
            >
              {I18n.t('update')}
            </button>
          </div>
        </form>
        {!!this.state.success && <p className="color-green margin-top-10">{this.state.success}</p>}
        {!!this.state.message && <p className="color-red margin-top-10">{this.state.message}</p>}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  updateTechnicalMaterial: technicalMaterialParameter => dispatch(
    updateTechnicalMaterial(technicalMaterialParameter),
  ),
  uploadFileTechnicalMaterial: (file, fileName, technicalMaterialId) => dispatch(
    uploadFileTechnicalMaterial(file, fileName, technicalMaterialId),
  ),
});

const mapStateToProps = state => ({
  settings: state.settings,
});

export default connect(mapStateToProps, mapDispatchToProps)(TechnicalMaterialForm);
